import { useEffect, useState } from "react";
import VerifyBg from "../../assets/images/Verifybg.svg";
import Button from "../../components/Button";
import ConfirmationCard from "../../components/ConfirmationCard";
import Modal from "../../components/Modal";
import Cookies from "js-cookie";
import SubscribeVerification from "./sections/SubscribeVerification";
import Tours from "./sections/Tours";
import TourSearch from "./sections/TourSearch";
import ToursInfoCards from "./sections/ToursInfoCards";
import Toursimg from "../../assets/images/Tours-img.svg";
// import ConnectionDiagram from "./sections/ConnectionDiagram";
import CustomDrawing from "./sections/CustomDrawing";
import { useDispatch, useSelector } from "react-redux";
import { fetchToursThunk } from "../../lib/service/tours/toursSlice";
import { fetchCategoriesThunk } from "../../lib/service/categories/categoriesSlice";
import Spinner from "../../components/Spinner";
import { fetchToursDetailsThunk } from "../../lib/service/tours/toursDetailsSlice";
import { useSelectedTours } from "../../contexts/SelectedToursContext";
import { addAttendance } from "../../lib/api/attendanceApi";
import { addAttendanceThunk } from "../../lib/service/attendance/attendanceSlice";
import ResponsiveToursCard from "./sections/ResponsiveToursCard";
import ResponsiveTours from "./sections/ResponsiveTours";
import { useTransformedData } from "../../contexts/TransformedDataContext";
import axios from "axios";
import { sendEmail } from "../../lib/service/otp/sendEmailSlice";
import ErrorMessage from "./../../components/ErrorMessage";
import toast from "react-hot-toast";

import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../../contexts/AuthContext";

function Verification() {
  const [flag, setFlag] = useState(false);
  const [namesArray, setNamesArray] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const { transformedData, setTransformedData } = useTransformedData();
  const { selectedTours, setSelectedTours } = useSelectedTours();
  const [attendanceData, setAttendanceData] = useState(null);
  const [addError, setAddError] = useState("");
  const { tours, loading, error } = useSelector((state) => state.tours);
  const [refreshToursFlag, setRefreshToursFlag] = useState(false);
  const location = useLocation();
  const status = location.state?.status;
  const { loggedIn, logout } = useAuth();

  useEffect(() => {
    if (status === true) {
      window.scrollTo({
        top: document.body.scrollHeight, // Scroll to the bottom of the page
        behavior: "smooth",
      });
    }
  }, [status]);

  const {
    details,
    loading: detailsLoading,
    error: detailsError,
  } = useSelector((state) => state.toursDetails);

  const {
    loading: loadingAttendance,
    success: successAttendance,
    error: errorAttendance,
  } = useSelector((state) => state.attendance);

  const {
    categories,
    loading: categoriesLoading,
    error: categoriesError,
  } = useSelector((state) => state.categories);
  const dispatch = useDispatch();
  const openModal = () => {
    setIsOpen(true); // Set the modal to open
  };

  const closeModal = () => {
    setIsOpen(false); // Close the modal
    setRefreshToursFlag((prev) => !prev); // Toggle the flag to trigger re-fetch
  };

  // Send email function

  // Axios states data
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(null);

  const newAttendanceData = useSelector((state) => state?.attendance?.data);

  const {
    loading: sendEmailLoading,
    success: sendEmailSuccess,
    error: sendEmailError,
  } = useSelector((state) => state.email);
  const [emailData, setEmailData] = useState({
    // date: "",
    // qr_code_url: "",
    // tour_ids: [],
    // category_ids: [],
    // start_times: [],
    // end_times: [],
  });

  useEffect(() => {
    if (newAttendanceData?.data?.attendance) {
      let tour_ids = [];
      let category_ids = [];
      let start_times = [];
      let end_times = [];

      newAttendanceData?.data?.attendance?.items?.forEach((data) => {
        tour_ids = tour_ids.concat(data?.tour_id);
        category_ids = category_ids.concat(data?.category_id);
        start_times = start_times.concat(data?.start_time);
        end_times = end_times.concat(data?.end_time);
      });

      const body = {
        date: newAttendanceData?.data?.attendance?.date,
        qr_code_url: newAttendanceData?.data?.attendance?.qr_image,
        tour_id: tour_ids,
        category_id: category_ids,
        start_time: start_times,
        end_time: end_times,
        venue_id: newAttendanceData?.data?.venues_id.split(","),
        // email: Cookies.get("email"),
      };

      setEmailData(body);
    }
  }, [newAttendanceData]);

  useEffect(() => {
    if (emailData && flag) {
      dispatch(sendEmail(emailData)); // Ensure emailData is valid and flag is true
    }
  }, [emailData, dispatch, flag]); // Add `flag` to the dependency array as well
  const customer_category_id = Cookies.get("customer_category_id");

  const handleAddAttendance = () => {
    const attendance = {
      customer_category_id: customer_category_id,
      customer_id: selectedTours[0]?.customerId,
      date: selectedTours[0]?.date,
      event_id: selectedTours[0]?.eventId,
      status: "booked",
      items: selectedTours?.map((item) => ({
        event_item_id: item.eventItemId,
        tour_id: item.tourId,
        category_id: item.categoryId,
        start_time: item.startTime,
        end_time: item.endTime,
        status: "booked",
      })),
    };

    setAttendanceData(attendance);
    dispatch(addAttendanceThunk({ attendance })).then((res) => {
      if (!res.error) {
        openModal();
        setAddError("");

        setFlag(true);
      } else {
        setAddError(res.error.message);

        toast.error(res.error.message);

        setFlag(false);
      }
    });
  };
  useEffect(() => {
    return setSelectedTours([]);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch tours
        const toursResponse = await dispatch(fetchToursThunk({logout})).unwrap();

        if (
          toursResponse.message ===
            "No tours found for the specified customer categories." ||
          toursResponse?.data?.length === 0
        ) {
          return; // Stop execution
        }
        // Extract service IDs

        const serviceIds = toursResponse?.data
          ?.flatMap((tour) => tour?.items) // Flatten all items arrays
          ?.map((item) => item?.service_id);

        // const hasProductIds = "1597,1598";
        const hasProductIds = serviceIds.join(",");

        // Fetch categories
        const categoriesResponse = await dispatch(
          fetchCategoriesThunk({ has_product_ids: hasProductIds })
        ).unwrap();

        // Fetch tour details using hasProductIds
        const toursDetailsResponse = await dispatch(
          fetchToursDetailsThunk({ products_id: hasProductIds })
        ).unwrap();
      } catch (error) {
        console.error("Error during data fetching:", error);
      }
    };

    fetchData();
  }, [dispatch, refreshToursFlag]);

  useEffect(() => {
    if (categories?.data && details?.data) {
      const transformed = categories?.data?.map((category) => {
        const matchingTours = tours?.data?.flatMap((d) => {
          return d.items.filter((tour) => {
            return tour.category_id?.split(",")?.includes(`${category.id}`);
          });
        });

        const customerID = Cookies.get("customerId");

        const eventIds = tours?.data?.flatMap((tour) =>
          tour?.items?.map((item) => item?.event_id)
        );

        return {
          id: category?.id,
          group: category?.title,
          tours: matchingTours?.map((tour) => ({
            id: tour.id,
            tour: details?.data?.find((x) => x.id == tour?.service_id)?.name,
            time: `${tour?.start_time?.slice(0, 5)} to ${tour?.end_time?.slice(0, 5)}`,
            startTime: tour?.start_time,
            endTime: tour?.end_time,
            tourId: tour?.service_id,
            eventItemId: tour?.id,
            eventId: eventIds,
            customerId: customerID,
            date: tour?.start?.split(" ")[0],
            categoryId: category?.id,
            booked: tour?.booked,
          })),
        };
      });

      setTransformedData(transformed);
    }
  }, [categories, details]);

  const divStyle = {
    backgroundImage: `url(${VerifyBg})`,
    backgroundSize: "cover", // or "contain" depending on your preference
    backgroundPosition: "top",
    width: "100%",
    height: "auto", // Adjust the height as needed
  };
  let maxToursLength = 0;

  transformedData?.forEach((item) => {
    if (item?.tours && item.tours.length > maxToursLength) {
      maxToursLength = item?.tours.length;
    }
  });
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false); // Modal visibility state

  const openErrorModal = () => setIsErrorModalOpen(true); // Function to open the modal
  const closeErrorModal = () => setIsErrorModalOpen(false); // Function to close the modal
  useEffect(() => {
    // Initialize debounce timeout
    const debounceTimeout = setTimeout(() => {
      // Check all loading states before setting isLoading
      if (
        loading ||
        categoriesLoading ||
        transformedData.length === 0 ||
        detailsLoading
      ) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }, 500); // Adjust delay (500ms) based on your preference

    // Clear timeout if dependencies change before the timeout finishes
    return () => clearTimeout(debounceTimeout);
  }, [
    loading,
    categoriesLoading,
    transformedData,
    detailsLoading,
    setIsLoading,
  ]);
  return (
    <>
      <Helmet>
        <title>Reservation - Leap</title>
        <meta
          name="description"
          content="Reserve your tour with Leap and make your experience unforgettable."
        />
      </Helmet>
      {isErrorModalOpen && (
        <Modal isOpen={openErrorModal} closeModal={closeErrorModal}>
          <ErrorMessage error={addError} onClick={closeErrorModal} />
        </Modal>
      )}

      {isErrorModalOpen && (
        <Modal isOpen={openErrorModal} closeModal={closeErrorModal}>
          <ErrorMessage error={addError} onClick={closeErrorModal} />
        </Modal>
      )}

      <div className="leap-pt-80 sm:leap-pt-60 md:leap-pt-32 lg:leap-pt-[10rem] xl:leap-pt-24 leap-bg-[#070322]"></div>
      <div style={divStyle}>
        <div>
          <div className="leap-text-center leap-absolute leap-top-40 leap-left-0 leap-right-0">
            <SubscribeVerification />
          </div>
        </div>
        <div className="leap-pt-[20rem] sm:leap-pt-[24rem] md:leap-pt-[26rem] lg:leap-pt-[28rem] xl:leap-pt-[28rem]  2xl:leap-pt-[40rem] 3xl:leap-pt-[45rem] 4xl:leap-pt-[54rem] 5xl:leap-pt-[65rem]">
          <ToursInfoCards />
        </div>
        <div className="leap-mt-10 leap-text-center leap-mx-auto">
          <h1 className="leap-bg-[linear-gradient(180deg,_#FFFFFF_0%,_#070322_139.86%)] leap-bg-clip-text">
            <span className="leap-uppercase leap-text-transparent leap-text-lg md:leap-text-2xl lg:leap-text-5xl">
              TECH TOURS SCHEDULE
            </span>
            <p className=" leap-text-transparent leap-text-base md:leap-text-xl lg:leap-text-4xl">
              Select your tour
            </p>
          </h1>
        </div>
        <div className="leap-mt-6">
          <TourSearch />
        </div>

        {tours?.message ===
          "No tours found for the specified customer categories." ||
        tours?.data?.length === 0 ? (
          <div className="absolute inset-0 z-10 flex items-center justify-center leap-my-6 bg-black/50">
            <p className=" leap-text-xl leap-text-center leap-font-bold leap-text-[#73FAFD]">
              No Tours Found
            </p>
          </div>
        ) : (
          <>
            {isLoading ? (
              <div className="absolute inset-0 z-10 flex items-center justify-center leap-my-6 bg-black/50">
                <Spinner />
              </div>
            ) : (
              <>
                <div className="leap-mt-6">
                  {/* Show Tours on md and above */}
                  <div className="leap-hidden eh:leap-block">
                    <Tours
                      isOpen={true}
                      tourData={transformedData}
                      imageSrc={Toursimg}
                      imageAlt="Tours Image"
                      containerHeight="1150px"
                      length={transformedData.length}
                      selectedTours={selectedTours}
                      setSelectedTours={setSelectedTours}
                    />
                  </div>

                  {/* Show ResponsiveTours below md */}
                  <div className="leap-block eh:leap-hidden">
                    <ResponsiveTours
                      isOpen={true}
                      tourData={transformedData}
                      imageSrc={Toursimg}
                      imageAlt="Tours Image"
                      containerHeight="1150px"
                      length={transformedData.length}
                      selectedTours={selectedTours}
                      setSelectedTours={setSelectedTours}
                    />
                  </div>
                </div>
                <div
                  className={`leap-my-6 leap-flex leap-justify-center leap-items-center leap-flex-col leap-gap-2 mobile-margin`}
                  style={{ marginTop: (maxToursLength - 1) * 180 }}
                >
                  {selectedTours.length > 0 && (
                    <div className="leap-relative">
                      <Button
                        text="Confirm"
                        bgColor="#73FAFD"
                        textColor="black"
                        customStyles="leap-w-[260px]"
                        onClick={handleAddAttendance}
                        disabled={loadingAttendance} // Optionally disable the button while loading
                      />
                      {loadingAttendance && (
                        <div className="leap-absolute leap-inset-0 leap-flex leap-items-center leap-rounded-2xl leap-bg-black/70 leap-justify-center">
                          <div className="leap-scale-50">
                            <Spinner />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {/* {addError && (
                    <span className="leap-text-red-500 leap-text-sm leap-px-2">
                      {addError}
                    </span>
                  )} */}
                </div>
              </>
            )}
          </>
        )}

        <div className="">
          <div>
            <div
              className={`leap-fixed leap-top-0 leap-left-0 leap-w-full leap-h-full leap-flex leap-justify-center leap-items-center leap-bg-black/50 leap-transition-opacity leap-duration-300 ${
                isOpen
                  ? "leap-opacity-100 leap-scale-100 leap-block"
                  : "leap-hidden leap-scale-90"
              }`}
            >
              <ConfirmationCard
                onClick={closeModal}
                selectedTours={selectedTours}
                setSelectedTours={setSelectedTours}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Verification;
